/* ─── A1CW Theme V15 · facet-filters.js ────────────────
   Auto-submit native Shopify filter form on input change.
   Mobile drawer open/close.
   ─────────────────────────────────────────────────────── */

(function () {
  'use strict';

  var form = document.querySelector('[data-facet-form]');
  var sidebar = document.querySelector('[data-facet-sidebar]');
  var overlay = document.querySelector('[data-facet-overlay]');
  var openBtn = document.querySelector('[data-facet-open]');
  var closeBtns = document.querySelectorAll('[data-facet-close]');

  // ── Auto-submit on filter change ─────────────────────
  if (form) {
    var debounce;

    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      submitForm();
    });

    form.addEventListener('input', function (e) {
      if (e.target.type !== 'number') return;
      clearTimeout(debounce);
      debounce = setTimeout(submitForm, 700);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitForm();
    });
  }

  function submitForm() {
    if (!form) return;
    var params = new URLSearchParams();
    var fd = new FormData(form);
    fd.forEach(function (value, key) {
      var v = String(value).trim();
      if (v) params.append(key, v);
    });
    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    window.location.href = url;
  }

  // ── Mobile drawer ────────────────────────────────────
  function openDrawer() {
    if (!sidebar) return;
    sidebar.setAttribute('data-open', 'true');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.classList.add('facet-drawer-open');
    var closeBtn = sidebar.querySelector('[data-facet-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!sidebar) return;
    sidebar.removeAttribute('data-open');
    if (overlay) overlay.removeAttribute('data-open');
    document.body.classList.remove('facet-drawer-open');
    if (openBtn) openBtn.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar && sidebar.getAttribute('data-open') === 'true') {
      closeDrawer();
    }
  });
})();
